import React, { useContext } from "react";
import moment from "moment";
import styles from "./index.module.scss";
import {
    DiscussDetail,
    getDurationSeconds
} from "../../../../../../../API/discuss";
import { isTrue } from "../../../../../../../Utils/filter";
import { DiscussContent } from "../../../../context";

interface TimeLimitProps {
    data: DiscussDetail;
}

export default function TimeLimit({ data }: TimeLimitProps) {
    const { isDead } = useContext(DiscussContent);
    const seconds = getDurationSeconds(data);

    if (!seconds) return null;

    if (isDead) {
        return <span className={styles.over}>当前讨论已截止</span>;
    }

    if (isTrue(data.isStart) && moment(data.deadline).isAfter()) {
        return (
            <span className={styles.limit}>
                当前讨论将于:&nbsp;
                {moment
                    .duration(moment(data.deadline).diff(moment()))
                    .humanize()}
                后截止
            </span>
        );
    }

    return null;
}
